import React from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface ITextAreaBoxProps {
	name: string;
	value: string;
	onValueChanged: (value: string) => void;
	label?: string;
	error?: string;
	rows?: number;
	sizeClass?: 'sm' | 'md' | 'lg';
	helpBlock?: string;
	placeholder?: string;
	labelSmall?: boolean;
	disabled?: boolean;
	hasValid?: boolean;
	className?: string;
	classWrapper?: string;
}

export const TextAreaBox = (props: ITextAreaBoxProps) => {
	const {
		error,
		name,
		value,
		label,
		rows = 3,
		sizeClass,
		disabled,
		helpBlock,
		labelSmall,
		hasValid,
		placeholder,
		className,
		classWrapper,
		onValueChanged,
	} = props;
	const showError = !!error;
    
	return (
		<div className={cn("space-y-2", classWrapper)}>
			{label && (
				<Label htmlFor={name} className={cn(labelSmall && "text-xs")}>
					{label} {hasValid && <span className='text-destructive'>(*)</span>}
				</Label>
			)}
			<div className="relative">
				<Textarea
					id={name}
					name={name}
					disabled={disabled}
					placeholder={placeholder}
					rows={rows}
					value={value || ''}
					onChange={(e) => onValueChanged(e.target.value)}
					className={cn(showError && "border-destructive", className)}
				/>
			</div>
			{showError && <p className="text-sm font-medium text-destructive">{error}</p>}
			{helpBlock && <p className="text-sm text-muted-foreground" dangerouslySetInnerHTML={{ __html: helpBlock }} />}
		</div>
	);
};
